<template>
    <div draggable="false" :style="styleDynamicElement(el)" class="image-container trigger-container" :class="el.getAnimationClass(currentElementIndex)" @mousedown="eventDrag($event, el.previewId)">
        <div :style="el.getStyle(currentElementIndex)">
        </div>
        <ShadowMedia v-if="el.Shadow" :el="el.Shadow"/>
        <div class="shadow-select"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-left" @mousedown="eventResize($event, el.previewId, 'left')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-right" @mousedown="eventResize($event, el.previewId, 'right')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-top" @mousedown="eventResize($event, el.previewId, 'top')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-bottom" @mousedown="eventResize($event, el.previewId, 'bottom')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-top-left" @mousedown="eventResize($event, el.previewId, 'top-left')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-top-right" @mousedown="eventResize($event, el.previewId, 'top-right')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-bottom-left" @mousedown="eventResize($event, el.previewId, 'bottom-left')"></div>
        <div v-if="el.objectType == 'ImageItem'" class="trigger-bottom-right" @mousedown="eventResize($event, el.previewId, 'bottom-right')"></div>
    </div>  
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
import ShadowMedia from "./shadow.vue";
export default {
    name: 'ImageMedia',
    extends: BasePreviewComponents,
    components: {
        ShadowMedia
    },
    methods: {
    }
}
</script>

<style scoped>
.image-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.shadow-select {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom: 0;
    opacity: 0;
    transition: all 0.5s ease;
    box-shadow: inset 0 0 20px 10px rgba(59, 130, 246,1);
    pointer-events: none;
}

.trigger-container.selected .shadow-select {
    opacity: 1;
}
</style>
